import styled from "@emotion/styled";

const Styles = styled.div`
  table,
  th,
  td {
    border-collapse: collapse;
    white-space: nowrap;
  }
  th,
  td {
    &.ant-table-cell {
      &.col-date {
        padding: 0 !important;
        min-width: 30px;
      }
    }
  }

  .ant-table-tbody {
    .ant-table-cell.col-date:hover {
      background: #ccc !important;
    }
    .ant-table-cell-row-hover {
      background: transparent !important;
    }
  }
`;
export default Styles;
 